export default "__VITE_ASSET__BAhWDNYa__"